import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import React, { useContext } from 'react'

import colorContext from '../../Context/colorContext'
import { UnavailabilityI } from '../../Pages/SearchService'

interface Props {
  openUnavailabilityModal: boolean
  handleClose: () => void
  currentUnavailabilityData: UnavailabilityI
}

export default function UnavailabilityModal({
  openUnavailabilityModal,
  handleClose,
  currentUnavailabilityData,
}: Props) {
  const { colors } = useContext(colorContext)

  const useStyles = makeStyles((theme) => ({
    paper: {
      width: '100%',
      maxWidth: '700px',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
        margin: theme.spacing(1),
      },
    },
    root: {
      backgroundColor: colors.colorBackground,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    titleDialog: {
      color: colors.colorBackground,
      backgroundColor: colors.accentColorBackground,
      paddingTop: 20,
      paddingBottom: 20,
      paddingRight: 40,
      [theme.breakpoints.down('sm')]: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingRight: 24,
        paddingLeft: 24,
        fontSize: '1.1rem',
      },
    },
    dialogActions: {
      backgroundColor: colors.colorBackground,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      justifyContent: 'center',
      borderTop: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
    closeButton: {
      color: colors.accentColor,
      fontWeight: 700,
      fontSize: 18,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
        opacity: 0.8,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
        padding: theme.spacing(1),
      },
    },
    contentDialog: {
      color: colors.textBody,
      textAlign: 'justify',
      lineHeight: '19px',
      wordBreak: 'break-word',
      [theme.breakpoints.down('sm')]: {
        lineHeight: '1.5',
        fontSize: '0.9rem',
      },
    },
  }))
  const classes = useStyles()

  const convertDate = (date: string) => {
    if (!date) return
    const parsedDate = new Date(date)
    return `${parsedDate.toLocaleString('pt-BR', {
      dateStyle: 'short',
    })} às ${parsedDate.getHours()}:${parsedDate
      .getMinutes()
      .toLocaleString('pt-BR', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}`
  }

  return (
    <Dialog
      open={openUnavailabilityModal}
      onClose={handleClose}
      aria-labelledby="block-dialog-title"
      maxWidth="lg"
      classes={{ paper: classes.paper }}
    >
      <DialogTitle className={classes.titleDialog}>
        {currentUnavailabilityData?.titulo}
      </DialogTitle>
      <DialogContent dividers classes={{ root: classes.root }}>
        <Box className={classes.contentDialog}>
          <p>
            <b>Período: </b>{' '}
            {convertDate(currentUnavailabilityData?.data_hora_inicio || '')} até{' '}
            {convertDate(currentUnavailabilityData?.data_hora_fim || '')}
          </p>
        </Box>
        <Divider />
        <Box className={classes.contentDialog}>
          <p>
            <b>Motivo: </b> {currentUnavailabilityData?.motivo}
          </p>
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          Fechar
        </IconButton>
      </DialogActions>
    </Dialog>
  )
}
